package com.wintermar.inspection.feature.presentation.inspection.complete.widget.header

import androidx.compose.runtime.Composable

/**
 * Non-mobile implementation of the Header composable.
 *
 * This implementation uses only a subset of the available callbacks from the common Header interface.
 *
 * **Used Callbacks:**
 * - [onDownloadPdf]: Handles PDF download functionality
 * - [onBack]: Handles back navigation
 * - [onShowConfirmApproval]: Shows the confirmation approval modal
 *
 * **Ignored Callbacks:**
 * - [showNavigate]: Not used in non-mobile layout
 * - [showPageModal]: Not used in non-mobile layout (page navigation handled differently)
 * - [onEdit]: Not used in non-mobile layout
 * - [onShowPageModal]: Not used in non-mobile layout (page modal not needed)
 *
 * The non-mobile (web/desktop) implementation renders a wide header ([InspectionCompleteHeaderWide])
 * that doesn't require page navigation UI or edit functionality.
 *
 * @param showNavigate Whether to show navigation (IGNORED in non-mobile)
 * @param showPageModal Whether page modal is shown (IGNORED in non-mobile)
 * @param onBack Callback when back button is clicked (USED)
 * @param onEdit Callback when edit button is clicked (IGNORED in non-mobile)
 * @param onShowConfirmApproval Callback to show approval confirmation (USED)
 * @param onShowPageModal Callback to show page selection modal (IGNORED in non-mobile)
 * @param onDownloadPdf Callback to download inspection as PDF (USED)
 */
@Composable
actual fun Header(
    showNavigate: Boolean,
    showPageModal: Boolean,
    onBack: () -> Unit,
    onEdit: () -> Unit,
    onShowConfirmApproval: () -> Unit,
    onShowPageModal: () -> Unit,
    onDownloadPdf: () -> Unit
) {
    InspectionCompleteHeaderWide(
        onDownloadPdf = onDownloadPdf,
        onBack = onBack,
        onShowConfirmApproval = onShowConfirmApproval
    )
}


